import { useEffect } from "react";
import { imageUploaderSelector } from "store/features/imageUploader/selectors/imageUploaderSelector";
import { ImageUpload } from "store/features/imageUploader/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { setImage, setUploadData } from "store/features/crop/actions";
import { ga } from "client/utils/adsense/ga";
import { gtag } from "client/utils/adsense/gtag";
import { reset } from "store/features/imageUploader/actions";
import { useRouter } from "next/router";
import { getImageExtension } from "client/utils/getImageExtension";
import translatedRoutedSlugs, { type TranslatedRouteSlugs } from "translatedRouteSlugs";

export const useCropUploader = () => {
    const { images } = useAppSelector(imageUploaderSelector);
    const dispatch = useAppDispatch();
    const router = useRouter();

    const handleProceed = (image: ImageUpload) => {
        if (!image.file) return;

        // setting dummy values for now
        // the editor will load the real values later

        dispatch(setUploadData(image.upload));
        dispatch(
            setImage({
                src: image.file.src,
                height: 0,
                width: 0,
                initialHeight: 0,
                initialWidth: 0,
                originalHeight: 0,
                originalWidth: 0,
                containerWidth: 0,
                containerHeight: 0,
                ratio: 0,
                title: image.file.file.name,
                ext: getImageExtension(image.file.file),
            }),
        );

        const urlPrefix = () => {
            if (router.asPath.includes("crop-png")) return "crop-png";
            if (router.asPath.includes("crop-jpg")) return "crop-jpg";
            if (router.asPath.includes("crop-webp")) return "crop-webp";
            return "crop-image";
        };

        router.push(
            `/${
                translatedRoutedSlugs[`/crop-image/editor`][
                    (router.locale as keyof TranslatedRouteSlugs["/crop-image/editor"]) ?? ""
                ]?.replace("crop-image", urlPrefix) || "crop-image/editor"
            }`,
        );
        dispatch(reset());
    };

    function deleteImage() {}
    function deleteAllImages() {}

    const handleLoadImageAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/image_cropper/image_loaded/",
            title: "Image Cropper Image Loaded",
        });

        ///event
        gtag("event", "Image Loaded", {
            event_category: "Image Cropper",
            event_label: "Upload Page",
        });
    };

    function checkImageStatus(images: ImageUpload[]) {
        const image = images[0];
        if (!image || image.fileState.status !== "added") return;
        handleLoadImageAnalytics();
        handleProceed(image);
    }

    useEffect(() => {
        checkImageStatus(images);
    }, [images]);

    return { deleteImage, deleteAllImages };
};
